'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _themeCurrency = require('@shopify/theme-currency');

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

var _cssClasses = require('../helpers/cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _svgMap = require('../helpers/svg-map');

var _quantitySelector = require('./quantity-selector');

var _quantitySelector2 = _interopRequireDefault(_quantitySelector);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
/**
 * Cart table
 * ------------------------------------------------------------------------------
 * An event based Ajax cart table
 *
 * @namespace cartTable
 */
var selectors = {
  subtotal: '[js-cart-table="subtotal"]',
  totalDiscount: '[js-cart-table="totalDiscount"]',
  quantitySelector: '[js-cart-table="quantitySelector"]',
  lineItem: '[js-ajax-cart="lineItem"]'
};

/**
 * Create new cart table object.
 */

exports.default = function (selector) {

  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    container: document.querySelector(selector),
    subtotal: document.querySelectorAll(selectors.subtotal),
    totalDiscount: document.querySelector(selectors.totalDiscount)
  };

  /**
   * Instance globals.
   */
  var timer = {};

  /**
   * Initialise component.
   */
  function init() {
    render();
    setListener();
  }

  /**
   * Set listeners.
   */
  function setListener() {
    Frame.EventBus.listen(['AjaxCart:itemRemoved'], function () {
      return render();
    });
    Frame.EventBus.listen(['AjaxCart:removingItem'], function (item) {
      return setLoadingState(item);
    });
  }

  /**
   * Render cart template.
   */
  function render() {
    _axios2.default.get('/cart.js').then(function (response) {
      nodeSelectors.container.innerHTML = getCartTemplate(response.data);
      constructQuantitySelectors();
      updateTotal(response.data);
      Frame.EventBus.emit('AjaxCart:reinit');
      return response.data;
    }).catch(function (error) {
      return error;
    });
  }

  /**
  * Get cart template
  * @param {object} data - Cart data.
  */
  function getCartTemplate(data) {
    return data.items.map(function (item, index) {
      if (item.id !== window.theme.giftWrap.id) {
        return getLineItemTemplate(item, index);
      }
    }).join('');
  }

  /**
  * Get line item template.
  * @param {object} item - Line item data object.
  */
  function getLineItemTemplate(item, index) {
    return '\n    <div id="updates_' + item.id + '" class="cart-table__item ajax-cart__line-item" js-ajax-cart="lineItem" data-key="' + item.key + '">\n      <div class="cart-table__image ajax-cart__image">\n        <a href="' + item.url + '">\n          <img src="' + item.image + '" alt="' + item.title + '">\n        </a>\n      </div>\n\n      <div class="cart-table__description">\n        <div class="row no-margin">\n          <div class="col xs12 l10">\n            <div class="ajax-cart__inner">\n              <a href="' + item.url + '" class="ajax-cart__title h6">' + item.product_title + '</a>\n\n              <p class="h6" js-currency="price" data-price=' + item.price + '>\n                ' + getLineItemPrice(item) + '\n              </p>\n\n              ' + getVariantTitle(item) + '\n\n              <span class="cart-table__remove ajax-cart__remove desktop h6" js-ajax-cart="remove" data-key="' + item.key + '">\n                Remove\n              </span>\n            </div>\n          </div>\n          <div class="col xs12 l2">\n            <div class="ajax-cart__price">\n              <div class="cart-table__quantity-selector" data-label="Quantity">\n                <label for="Quantity-' + index + '" class="label visually-hidden">Quantity</label>\n                <div id="QuantitySelector-' + index + '" class="quantity-selector quantity-selector--small" js-cart-table="quantitySelector">\n                  <div class="quantity-selector__control">\n                    <button class="button quantity-selector__button" js-quantity-selector="decrement" value="decrement">\n                      ' + _svgMap.misc.minus + '\n                      <span class="visually-hidden">-</span>\n                    </button>\n                  </div>\n\n                  <div class="quantity-selector__control">\n                    <input type="number" id="Quantity-' + index + '" name="quantity" value="' + item.quantity + '" min="1" pattern="[0-9]*" class="quantity-selector__input" js-quantity-selector="input" readonly />\n                  </div>\n\n                  <div class="quantity-selector__control">\n                    <button class="button quantity-selector__button" js-quantity-selector="increment" value="increment">\n                      ' + _svgMap.misc.plus + '\n                      <span class="visually-hidden">+</span>\n                    </button>\n                  </div>\n                </div>\n              </div>\n              <span class="cart-table__remove ajax-cart__remove mobile h6" js-ajax-cart="remove" data-key="' + item.key + '">\n                Remove\n              </span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    ';
  }

  /**
   * Get variant titles.
   * @param {object} item - Line item data object.
   */
  function getVariantTitle(item) {
    return item.variant_options.length && !item.variant_options[0].includes('Default Title') ? '<p class="ajax-cart__variant h6">SIZE: ' + item.variant_title + '</p>' : '';
  }

  /**
   * Get formatted line item price.
   * @param {object} item - Line item data object.
   */
  function getLineItemPrice(item) {
    return item.properties && item.properties._compare_at_price > item.line_price ? '<s>' + (0, _themeCurrency.formatMoney)(item.properties._compare_at_price, theme.moneyFormat) + '</s> ' + (0, _themeCurrency.formatMoney)(item.line_price, theme.moneyFormat) : '' + (0, _themeCurrency.formatMoney)(item.line_price, theme.moneyFormat);
  }

  /**
   * Instantiate quantity selectors using id.
   * - Callback has a timer to reduce number of calls.
   */
  function constructQuantitySelectors() {
    var quantitySelectors = document.querySelectorAll(selectors.quantitySelector);

    [].concat((0, _toConsumableArray3.default)(quantitySelectors)).forEach(function (item) {
      (0, _quantitySelector2.default)('' + item.id, function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          handleQuantityEvent(item);
        }, 250);
      }).init();
    });
  }

  /**
   * Handle quantity updates.
   * @param {HTMLElement} element - Quantity selector node element.
   */
  function handleQuantityEvent(element) {
    var data = {
      key: element.closest(selectors.lineItem).dataset.key,
      quantity: parseInt(element.querySelector('input').value, 10)
    };

    cart.updateItem(data.key, { quantity: data.quantity }).then(function (response) {
      updateSubtotal(response.total_price);
      updateDiscountTotal(response.total_discount);

      Frame.EventBus.emit('AjaxCart:itemUpdated');
      return response;
    }).catch(function (error) {
      return error;
    });
  }

  /**
   * Update subtotal and discount total.
   * @param {object} data - Cart response data.
   */
  function updateTotal(data) {
    updateSubtotal(data.total_price);
    updateDiscountTotal(data.total_discount);
  }

  /**
  * Update subtotal.
  * @param {Number} price - Total cart price number.
  */
  function updateSubtotal(price) {
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.subtotal)).forEach(function (element) {
      element.innerHTML = (0, _themeCurrency.formatMoney)(price, theme.moneyFormat);
    });
  }

  /**
   * Update discount total.
   * @param {Number} price - Total discount price number.
   */
  function updateDiscountTotal(price) {
    if (!isCartDiscounted(price)) {
      hideDiscountLabel();
      return;
    }
    showDiscountLabel();
    nodeSelectors.totalDiscount.innerHTML = (0, _themeCurrency.formatMoney)(price, theme.moneyFormat);
  }

  /**
   * Set loading state.
   * @param {object} element - Line item row in DOM.
   */
  function setLoadingState(element) {
    element.classList.add(_cssClasses2.default.isRemoving);
  }

  /**
   * Check discount total.
   * @param {Number} total - Total discount price number.
   */
  function isCartDiscounted(total) {
    return total > 0;
  }

  /**
   * Hide discount label.
   */
  function hideDiscountLabel() {
    nodeSelectors.totalDiscount.parentElement.classList.add(_cssClasses2.default.hidden);
  }

  /**
   * Show discount label.
   */
  function showDiscountLabel() {
    nodeSelectors.totalDiscount.parentElement.classList.remove(_cssClasses2.default.hidden);
  }

  return Object.freeze({
    init: init
  });
};